"use client"

import React from "react"
import { NotificationItemTemplate } from "./NotificationItemTemplate"
import { FragmentType, graphql, useFragment } from "@/gql"
import { NotificationActor } from "./NotificationActor"
import { Text } from "@/elements"
import { useRouter } from "next-nprogress-bar"
import { useSidebar } from "../Sidebar/useSidebar"
import { UserNotificationFeedItem } from "@/gql/graphql"
import { ampli } from "@/ampli"
import { decodeGraphqlNodeId } from "@/tracking"

const CreativeWorkProjectLikeFragment = graphql(`
  fragment CreativeWorkProjectLike on StreamNotificationFeedAggregatedActivity {
    id
    isRead
    isSeen
    activities {
      id
      time
      actor {
        id
        name
        ... on IndividualCreative {
          handle
        }
        ...NotificationActor
      }
      object {
        __typename
        ... on CreativeWorkPortfolioProject {
          id
          title
        }
        ... on CreativeWorkPortfolioProjectCreativeContributor {
          project {
            id
            title
          }
        }
      }
    }
  }
`)

interface Props {
  onActorClick: (e: React.MouseEvent<any, MouseEvent>) => void
  item: FragmentType<typeof CreativeWorkProjectLikeFragment>
  onClick: (type: UserNotificationFeedItem) => void
}

const CreativeWorkProjectLike: React.FC<Props> = props => {
  const item = useFragment(CreativeWorkProjectLikeFragment, props.item)
  const router = useRouter()
  const { closeSecondaryBar } = useSidebar()

  const { onActorClick, onClick } = props
  const activities = item.activities?.[0]
  const handle = activities?.actor?.__typename === "IndividualCreative" && activities?.actor?.handle
  const projectId = activities?.object?.__typename === "CreativeWorkPortfolioProject" && activities?.object?.id

  const canNavigateToProject = handle && projectId

  const handleClick = () => {
    onClick(UserNotificationFeedItem.CreativeWorkProjectLiked)
    if (canNavigateToProject) {
      closeSecondaryBar()
      router.push(`/${handle}/projects/${projectId}`)
      ampli.projectView({
        project_id: decodeGraphqlNodeId(projectId).numericalId || "",
        entry_point: "project-like-notification",
      })
    }
  }

  const actor = activities?.actor
  const actorName = actor?.name
  const object = activities?.object
  const title =
    object?.__typename === "CreativeWorkPortfolioProject"
      ? object.title
      : object?.__typename === "CreativeWorkPortfolioProjectCreativeContributor"
        ? object.project.title
        : null

  return (
    <NotificationItemTemplate
      isSeen={item.isSeen}
      LeftComponent={actor && <NotificationActor actor={actor} onActorClick={onActorClick} />}
      onClick={canNavigateToProject ? handleClick : undefined}
      TextContent={
        <Text element="span">
          <Text element="span" className="!font-medium" onClick={onActorClick}>
            {actorName ?? "Member"}
          </Text>{" "}
          liked{" "}
          <Text element="span" className="!font-medium" onClick={handleClick}>
            {title}
          </Text>
        </Text>
      }
      time={activities?.time}
    />
  )
}
export default CreativeWorkProjectLike
